<mat-card class="cb-margin flex-row flex">
    <mat-card-content class="flex-col flex flex-fill" *cbWaitFor="mappedItem">
        @if (!mappedItem.isCancelled()) {
            <div class="end-end flex-row flex">
                <button
                    mat-raised-button
                    color="primary"
                    class="cb-margin-right-2x"
                    (cbClick)="dialog(undefined)"
                    [disabled]="!projectReleaseStagePermissions.canEdit()"
                >
                    Add
                </button>
                <button
                    mat-raised-button
                    color="primary"
                    (cbClick)="addAll()"
                    [disabled]="!projectReleaseStagePermissions.canEdit()"
                >
                    Reset
                </button>
            </div>
        }
        <cb-table
            *cbWaitFor="mappedItem"
            class="cb-margin-top-3x cb-margin-bottom-3x flex"
            [loaded]="loaded"
        >
            <thead cbTableHead>
                <tr>
                    <td>Supply Type</td>
                    <td>Business Account</td>
                    <td></td>
                </tr>
            </thead>
            <tbody cbTableBody>
                @for (
                    defaultSupplier of mappedItem.defaultProductSuppliers;
                    track defaultSupplier
                ) {
                    <tr>
                        <td>{{ defaultSupplier.supplyType.path }}</td>
                        <td>{{ defaultSupplier.supplier.label }}</td>
                        <td class="actions">
                            @if (!mappedItem.isCancelled()) {
                                <button mat-icon-button (cbClick)="dialog(defaultSupplier, $index)">
                                    <mat-icon class="material-icons">edit_mode</mat-icon>
                                </button>
                            }
                            @if (!mappedItem.isCancelled()) {
                                <button
                                    mat-icon-button
                                    (cbClick)="deleteClick(defaultSupplier, $index)"
                                >
                                    <mat-icon class="material-icons">delete</mat-icon>
                                </button>
                            }
                        </td>
                    </tr>
                }
                @if (
                    !mappedItem.defaultProductSuppliers.length ||
                    mappedItem.defaultProductSuppliers.length < 1
                ) {
                    <tr>
                        <td colspan="3">
                            <cb-info-message
                                [message]="'There are no Default Suppliers to display'"
                                [icon]="'info_circle'"
                                iconClass="cb-accent"
                            ></cb-info-message>
                        </td>
                    </tr>
                }
            </tbody>
        </cb-table>
    </mat-card-content>
</mat-card>
